import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { LeftPageHeader } from 'Components/Public/PageHeader/PageHeader';
import { IconTextButton, TextButton } from 'Components/Button';
import { Collapse, Table} from 'react-bootstrap';
import { useEffect, useState } from 'react';
import DetailRow from './DetailRow';
import { CTCallToAction } from 'Components/Public/CTCallToAction/CTCallToAction';
import { useParams } from 'react-router-dom';
import { http } from 'Utils';
import HL7Modal from './HL7Modal';
import { PATHS } from 'Utils/PagePaths';
import { HashLink } from 'react-router-hash-link';
import { Fragment } from 'react';
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { useDispatch } from 'react-redux';
import { ERROR_MESSAGES } from 'Utils/constants';

function RepositoryDetails ({setCustomCrumb, setCustomPrevCrumb}) {

    const {verId, deId} = useParams();  // URL parameters

    const [crumb, setCrumb] = useState(null);   // Breadcrumb data
    const [prevCrumb, setPrevCrumb] = useState(null);   // Previous breadcrumb data

    const [deData, setDeData] = useState(null); //DE attribute info
    const [deDomainData, setDeDomainData] = useState(null); //DE domain data for table
    const [cTLinkInfo, setCTLinkInfo] = useState(null); // CT DE access info

    const [showModal, setShowModal] = useState(false);  // Show HL7 modal
    const [showAdditional, setShowAdditional] = useState(false);    // Show all DE attributes

    const dispatch = useDispatch();

    // Get DE data on initial load
    useEffect(()=>{
        getDe(verId, deId);
    },[])
    
    // Set breadcrumbs
    useEffect(()=>{
        if(prevCrumb!=null && crumb!=null){
            setCustomCrumb(crumb);
            setCustomPrevCrumb(prevCrumb);
        }
    }, [crumb,prevCrumb])

    // Get formatted attribute data
    const getDetailRows = (data,start,end) => {
         var detailRows = [
            {
                num: 1,
                attribute: "Question",
                value: data.deQuestion
            },
            {
                num: 2,
                attribute: "Allowed to Submit",
                value: data.deAllowSubmit
            },
            {
                num: 3,
                attribute: "CDA Header",
                value: data.deCdaHeaderSection
            },
            {
                num: 4,
                attribute: "HL7 Data Type",
                value: data.deHl7DataType
            },
            {
                num: 5,
                attribute: "CDA Element/Attribute",
                value: data.deCdaElementAttribute
            },
            {
                num: 6,
                attribute: "CDA Entry-Level Template ID",
                value: data.deCdaEntryLvlTemplId
            },
            {
                num: 7,
                attribute: "Type of Representation",
                value: data.deTypeOfPresentation
            },
            {
                num: 8,
                attribute: "Answer Value Set Object Identifier (OID)",
                value: data.deAnswerValueSetOid
            },
            {
                num: 9,
                attribute: "Multiple Answer Values Allowed",
                value: data.deMultipleChoice
            },
            {
                num: 10,
                attribute: "Data Type",
                value: data.deDataType
            },
            {
                num: 11,
                attribute: "Maximum Length",
                value: data.deMaxLength
            },
            {
                num: 12,
                attribute: "Applicable NullFlavor",
                value: data.deNullFlavor
            },
            {
                num: 13,
                attribute: "Special Instruction",
                value: data.deSpecialInstruction!=null ? data.deSpecialInstruction : "NA"
            },
            
        ]
        return detailRows.slice(start,end);
    }
    
    // Get url to return to CF Repo version and module where DE resides
    const getRepoPath = (verId, modId) =>{
        if(modId==null){
            return PATHS.public['Common Formats Repository'] + "?v=" + verId;
        }
        return PATHS.public['Common Formats Repository'] + "?v=" + verId + "&m=" + modId;
    }

    // API call to get DE details
    const getDe = async (versionId, code) => {
        const call = async () => {
            var url = "/api/cfRepo/deDetail";
            return http.post(url, {
                versionId: versionId,
                deCode: code
            });
        }
        return call().then((response) => {
            if (response.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: false 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            else {
                setDeData(response.data);
                getDeValDomain(verId, response.data.dataElementId);
                setPrevCrumb({
                    replace: true, 
                    value: response.data.versionName, 
                    path: getRepoPath(verId,response.data.deModuleId), 
                    state:{
                        verId: verId,
                        deId: deId,
                        modId: response.data.deModuleId
                    }
                });
                setCrumb({replace: true, value: "Data Element - "  + code});
                setCTLinkInfo(response.data.ctLinkInfo);
            }
            return response;
        }).catch((error)=>{
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });
    }

    // API call to get DE value domain
    const getDeValDomain = async (versionId, deId) => {
        const call = async () => {
            var url = "/api/cfRepo/deValueDomain";
            return http.post(url, {
                versionId: versionId,
                deId: deId
            });
        }
        return call().then((response) => {
            if (response.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: false 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
            }
            else {
                setDeDomainData(response.data);
            }
            return response;
        }).catch((error)=>{
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });
    }

    return (
        <Fragment>
            {   
                deData!=null 
                ?   
                    <Row className="m-0 p-0">
                        <LeftPageHeader
                            subTitle={deData.versionName + " - " + deData.deModuleName + " - " + deData.deGroupName}
                            title={deData.deName}
                            intro={<span className="">{deData.deDefinition}</span>}
                            rightContent={
                                <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content ms-auto me-auto h-100 justify-content-center mt-2 mb-2">
                                    <div className="d-flex flex-column gap-4">
                                        {/* Link to return to CF Repo version and module where DE resides */}
                                        <TextButton
                                            variant={"normal"}
                                            as={HashLink}
                                            to={getRepoPath(verId,deData.deModuleId)}
                                            elementId="repository-main-content"
                                            content={"Back to Data Repository"}
                                            className=""
                                        />
                                    </div>
                                </div>
                            }
                            topRowSizes = {{
                                column1: {
                                    xs: 11,
                                    sm: 11,
                                    md: 5,
                                    lg: 6,
                                    xl: 5,
                                    xxl: 4
                                },
                                column2: {
                                    xs: 11,
                                    sm: 11,
                                    md: 5,
                                    lg: 4,
                                    xl: 4,
                                    xxl: 4
                                }
                            }}
                        >
                        </LeftPageHeader>

                        {/* HL7 Modal */}
                        <HL7Modal
                            key={"hl7-modal-el"}
                            showModal={showModal}
                            setShowModal={setShowModal}
                        >
                        </HL7Modal>

                        <Row lg={1} className={"main-content repo-main mb-40px  my-lg-60px mt-40px mt-lg-72px gap-64px gap-lg-80px p-0 d-flex justify-content-center g-0 px-3 px-sm-4 px-md-0" + (deDomainData==null || deDomainData.length<=0 ? ' mb-lg-72px' : " mb-lg-40px")}>
                            <Row className="m-0 p-0 d-flex justify-content-center gap-64px gap-lg-32px">
                                <Col key={"top-section"} xxl={8} xl={9} lg={10} md={10} sm={12} className="d-flex flex-column flex-lg-row text-start align-content-center justify-content-between gap-30px gap-lg-48px px-0 px-lg-0">
                                    <div className="d-flex flex-column text-start align-content-center gap-4 px-0 w-100">
                                        <h2 className="header2 bold mb-0 color-base-black">Data Element ID{deData.deRequired==1 ?<i>(required)</i>: null}: {deData.deCode}</h2>
                                        <div className="d-grid repo-detail-rows ">
                                            {
                                                // DE attribute rows #1-4
                                                getDetailRows(deData,0,4).map((row)=>{
                                                    return (
                                                        <DetailRow 
                                                            key={"detail-row-el-"+row.num}
                                                            num={row.num}
                                                            attribute={row.attribute}
                                                            value={row.value}
                                                            tooltipAction={()=>{
                                                                setShowModal(true);
                                                            }}
                                                        />
                                                    )
                                                })
                                            }
                                        </div>
                                        
                                        {/* Show additional rows if showAdditional is true or no domain data for DE */}
                                        <Collapse in={(deDomainData==null || deDomainData.length<=0) || showAdditional}>
                                            <div>
                                                <div className="d-grid repo-detail-rows ">
                                                    {
                                                        // DE attribute rows #5 and on
                                                        getDetailRows(deData, 4).map((row)=>{
                                                            return (
                                                                <DetailRow 
                                                                    key={"detail-row-el-"+row.num}
                                                                    num={row.num}
                                                                    attribute={row.attribute}
                                                                    value={row.value}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </Collapse>

                                        {
                                            // Only need show more btn if DE has domain data, attributes always expanded when no domain data table
                                            deDomainData!=null && deDomainData.length>0
                                            ?
                                                <IconTextButton 
                                                    variant="comp-view-more"
                                                    className="reverse d-flex justify-content-center view-more-btn"
                                                    onClick={()=>setShowAdditional(!showAdditional)} 
                                                    content={showAdditional==false ? 'View More' : 'View Less'}
                                                    icon={()=>{
                                                        return (
                                                            <svg className={showAdditional==true ? "down-icon" : ""} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z" fill="#686E7A"/>
                                                            </svg>
                                                        )
                                                    }}
                                                >
                                                </IconTextButton>
                                            :   null
                                        }
                                    </div>
                                    <div>
                                        {/* Link to DE in commenting tool */}
                                        <CTCallToAction cTLinkInfo={cTLinkInfo}></CTCallToAction>
                                    </div>
                                </Col>

                                {
                                    // Only show table when de domain data is greater than 0
                                    deDomainData!=null && deDomainData.length>0
                                    ?   
                                        <Col key={"table-section"} xxl={8} xl={9} lg={10} md={10} sm={12} className="d-flex flex-row text-start align-content-center gap-48px px-0 table-container scroll-shadows wrapper">
                                            <Table variant="value-domain" className="content">
                                                <thead>
                                                    {/* Add title for table */}
                                                    <tr className="table-title-row">
                                                        <th colspan="5" className="table-title header4 semibold">Value Domain</th>
                                                    </tr>

                                                    {/* Add table column headers */}
                                                    <tr className="table-col-headers">
                                                        <th className="answer-code">
                                                            <div className="col-title">
                                                                Code
                                                            </div>
                                                        </th>       
                                                        <th className="answer-value">
                                                            <div className="col-title">
                                                                Value
                                                            </div>
                                                        </th>
                                                        <th className="answer-description">
                                                            <div className="col-title">
                                                                Answer Value Set OID
                                                            </div>
                                                        </th>
                                                        <th className="code-system-name">
                                                            <div className="col-title">
                                                                Code System
                                                            </div>
                                                        </th>
                                                        <th className="code-system-desc">
                                                            <div className="col-title">
                                                                Code System Name
                                                            </div>
                                                        </th> 
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        deDomainData!=null 
                                                        ?
                                                            // Add table row for each element in deDomainData
                                                            deDomainData.map((row)=>{
                                                                return (
                                                                    <tr>
                                                                        <td className="body semibold color-base-darkgray answer-code">{row.answerCode}</td>
                                                                        <td className="body semibold color-base-black answer-value">{row.answerValue}</td>
                                                                        <td className="body regular color-base-black answer-description">{row.deAnswerValueSetOid}</td>
                                                                        <td className="body regular color-base-black code-system-name">{row.codeSystemName}</td>
                                                                        <td className="body regular color-base-black code-system-desc">{row.codeSystemDesc}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        :   null
                                                    }
                                                </tbody>
                                            </Table>
                                        </Col>
                                    :   null
                                }
                            </Row>
                        </Row>
                    </Row>
                :   null
            }
        </Fragment>
    );
}

export default RepositoryDetails;
